import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap, of, catchError, throwError } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';
import { WorkflowStateTypes } from '../../../workflows/model/workflow-state-types.model';
import { Roles } from '../../roles/model/roles.model';

@Injectable({
    providedIn: 'root'
})
export class StatePermissionsService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    index(): Observable<any> {
        return this.get<any>(EndPoints.statePermissions_Index).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    create(role: Roles, workflowStateType: WorkflowStateTypes): Observable<any> {
        return this.post<any>(EndPoints.statePermissions_Create, false, '', {
            role: role,
            state: workflowStateType
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    deleteStatePermission(role: Roles, workflowStateType: WorkflowStateTypes): Observable<any> {
        return this.post<any>(EndPoints.statePermissions_Delete, false, '', {
            role: role,
            state: workflowStateType
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }
}
